import { useRoutes } from 'react-router-dom'
import { appRoutes } from './routes'
import './styles/normalize.css'
import './App.less'

function App() {
  return useRoutes(appRoutes())
}

export default App
